module.exports = __webpack_public_path__ + "img/equipo_16-9_960.8f45a20f.jpg";